import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DownloadTabs from './components/DownloadTabs';
import AddressList from './components/AddressList';
import Features from './components/Features';
import InstallSteps from './components/InstallSteps';
import Devices from './components/Devices';
import CtaBanner from './components/CtaBanner';
import Changelog from './components/Changelog';
import Faq from './components/Faq';
import Safety from './components/Safety';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <Navbar />
      <main>
        <Hero />
        <DownloadTabs />
        <AddressList />
        <Features />
        <InstallSteps />
        <Devices />
        <CtaBanner />
        <Changelog />
        <Faq />
        <Safety />
      </main>
      <Footer />
    </div>
  );
}